<template>
  <div :class="{ 'shine-animation': isActive }">
    <slot />
  </div>
</template>

<script setup lang="ts">
const { isActive = true, duration = 4 } = defineProps<{
  isActive?: boolean
  duration?: number | string
}>()

const animationDuration = computed(() => `${duration}s`)
</script>

<style scoped>
.shine-animation {
  position: relative;
  overflow: hidden;
  border-radius: var(--border-radius-100);

  &::before {
    content: '';

    position: absolute;
    top: -70%;
    left: -70%;
    transform: rotate(-30deg);

    display: block;

    width: 140%;
    height: 100%;

    opacity: 0.4;
    background-image: linear-gradient(
      180deg,
      rgb(255 255 255 / 0%),
      rgb(255 255 255 / 70%) 40%,
      rgb(255 255 255 / 50%) 60%,
      rgb(255 255 255 / 0%)
    );

    transition: 0.25s cubic-bezier(0, 0.3, 1, 0.7);
    animation-name: shine;
    animation-duration: v-bind(animationDuration);
    animation-iteration-count: infinite;
  }
}

@keyframes shine {
  0% {
    top: -90%;
    left: -90%;
  }

  50% {
    top: -90%;
    left: -90%;
  }

  70% {
    top: 90%;
    left: 50%;
  }

  100% {
    top: 90%;
    left: 50%;
  }
}
</style>
